import React, { forwardRef } from 'react';
import { TextField } from '@mui/material';
import { COLOR_BLACK_HAZE, COLOR_DENIM, COLOR_REGENT_ST_BLUE } from '../../popTheme';

const PopPhoneInputField = (props, ref) => {
  return (
    <TextField
      {...props}
      inputRef={ref}
      fullWidth
      size="small"
      sx={{
        input: {
          color: COLOR_DENIM,
        },
        bgcolor: COLOR_BLACK_HAZE,
        borderRadius: '0.375rem',
        borderColor: COLOR_REGENT_ST_BLUE,
        mt: '0.5rem',
        mb: '0.75rem',
        '& .MuiInputBase-input': {
            fontSize: '1rem',
        },
      }}
      inputProps={{ maxLength: 16 }}
    />
  );
};

export default forwardRef(PopPhoneInputField);
